import React, { useEffect, useRef, useCallback } from 'react';
import ApexCharts from 'apexcharts';

interface GraficoRoscaProps {
  series: number[];
  chart: ChartOptions['chart'];
  width?: number;
  labels: string[];
  themeMode?: 'dark' | 'light';
}

interface ChartOptions {
  series: number[];
  chart: {
    type: string;
    width?: number;
  };
  labels: string[];
  colors: ['#509bc7', '#fc9228'];
  theme?: {
    mode?: 'dark' | 'light' | undefined;
  };
  legend?: {
    show: boolean;
  };
  responsive?: {
    breakpoint: number;
    options: {
      chart: {
        width: number;
        height: number;
      };
      legend?: {  // Alterado para opcional
        position: string;
      };
    };
  }[];
}


const GraficoRosca: React.FC<GraficoRoscaProps> = ({
  series,
  chart,
  width = 300,
  labels,
  themeMode = 'dark', // Default to 'dark' if not provided
}) => {
  const options: ChartOptions = {
    series,
    chart: {
      ...chart,
      width,
    },
    labels,
    colors: ['#509bc7', '#fc9228'],
    theme: {
      mode: themeMode,
    },
    legend: {
      show: false // Remove a legenda com segurança
    },
    responsive: [] // Sem conflito de tipagem
  };

  const chartRef = useRef<ApexCharts | null>(null);

  const renderChart = useCallback(() => {
    if (chartRef.current) {
      chartRef.current.destroy();
    }

    chartRef.current = new ApexCharts(document.querySelector('#chart'), options);
    chartRef.current.render();
  }, [options]);

  useEffect(() => {
    renderChart();

    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, [renderChart]);

  return <div id="chart" />;
};

export default GraficoRosca;
